import axios, { tryRequest, Response } from 'utils/axios'

export const loggingOut = (): Promise<Response<void>> =>
  tryRequest(axios.post('auth/logout'))
